export default class ItemDistance {
  distance(item1, item2) {}
}
